export enum Laterality {
  right = 'right',
  left = 'left'
}
